export interface TopItem {
  name: string;
  orders: number;
  revenue: number;
  trend: 'up' | 'down' | 'stable';
}

interface TopItemsProps {
  items: TopItem[];
}

export default function TopItems({ items }: TopItemsProps) {
  return (
    <div className="bg-background-50 border border-background-200 rounded-lg p-4 md:p-5">
      <h4 className="text-sm font-semibold text-foreground-800 mb-3">Top Items</h4>
      {items.length === 0 ? (
        <div className="py-10 flex flex-col items-center gap-2 text-center">
          <i className="ri-restaurant-2-line text-2xl text-foreground-300"></i>
          <p className="text-sm text-foreground-400">No items sold in the last 7 days</p>
        </div>
      ) : (
        <div className="space-y-1">
          {items.map((item, i) => (
            <div
              key={item.name}
              className="flex items-center gap-3 py-2 px-2 rounded-md hover:bg-background-100 transition-colors cursor-pointer"
            >
              <span className="text-xs font-semibold text-foreground-400 w-5 text-center">{i + 1}</span>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-foreground-700 truncate">{item.name}</p>
                <div className="flex items-center gap-3 mt-0.5">
                  <span className="text-xs text-foreground-400">{item.orders} sold</span>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">₹{item.revenue.toLocaleString('en-IN')}</span>
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${
                    item.trend === 'up' ? 'ri-arrow-up-line text-secondary-500' :
                    item.trend === 'down' ? 'ri-arrow-down-line text-accent-500' :
                    'ri-subtract-line text-foreground-400'
                  } text-sm`}></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
